#import "../fragments/stageset-basic.graphql"

mutation StagesetActivateDraft($input: StagesetActivateDraftInput!) {
    stagesetActivateDraft(input: $input) {
        stageset {
            ...StagesetBasic
        }
    }
}
